import { ReactElement, useContext, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthContext from "../../store/AuthContext";
import "../../assets/css/PageSurface.css";
import "../../assets/css/Text.css";
import "../../assets/css/InputText.css";
import { getManageSecondmentList, ManageSecondmentActor, ManageSecondmentRow } from "../../Services/ManageSecondments";
import ManageSecondmentsForm from "./components/ManageSecondmentsForm";
import ManageSecondmentsList from "./components/ManageSecondmentsList";

function actorFrom(person: { legacyId?: string; firmLegacyId?: string; firmAdminAccess?: boolean; name?: string; lastName?: string }): ManageSecondmentActor | null {
  if (!person.legacyId || !person.firmLegacyId) {
    return null;
  }
  return {
    contactId: String(person.legacyId),
    companyId: String(person.firmLegacyId),
    isFirmAdmin: Boolean(person.firmAdminAccess),
    firstName: person.name || "",
    lastName: person.lastName || "",
  };
}

export default function ManageSecondmentsPage(): ReactElement {
  const { loggedPerson } = useContext(AuthContext);
  const [params] = useSearchParams();
  const action = params.get("action") || "";
  const secId = params.get("id") || "";
  const actor = useMemo(() => (loggedPerson ? actorFrom(loggedPerson) : null), [loggedPerson]);
  const [rows, setRows] = useState<ManageSecondmentRow[] | null>(null);
  const [error, setError] = useState("");
  const showForm = action === "add" || action === "update";

  useEffect(() => {
    if (!actor || showForm) {
      return;
    }
    let cancelled = false;
    setError("");
    setRows(null);
    getManageSecondmentList(actor)
      .then((result) => {
        if (!cancelled) {
          setRows(result);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError("Firm secondments could not be loaded.");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [actor, showForm]);

  return (
    <div className="page-sheet">
      {!actor ? <p className="form-status">Sign in with a firm profile to manage secondments.</p> : null}
      {actor && showForm ? <ManageSecondmentsForm actor={actor} mode={action === "update" ? "update" : "add"} secId={secId} /> : null}
      {actor && !showForm && error ? <p className="form-status">{error}</p> : null}
      {actor && !showForm && !error && !rows ? <p className="form-status">Loading firm secondments.</p> : null}
      {actor && !showForm && rows ? <ManageSecondmentsList actor={actor} rows={rows} onChange={setRows} /> : null}
    </div>
  );
}
